(() => {
  const MARKER = 'md-personalization';
  const ROOT = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';

  if (!document.getElementById('mellowden-personalization-overrides')) {
    const style = document.createElement('style');
    style.id = 'mellowden-personalization-overrides';
    style.textContent = `form[data-mellowden-personalization="1"] .add-to-cart__added{display:none!important}`;
    document.head.appendChild(style);
  }

  function isMellowdenForm(form) {
    if (!form || !form.matches('form[action*="/cart/add"]')) return false;
    if (/\/products\/mellowden-/i.test(window.location.pathname)) return true;
    const container = form.closest('dialog, quick-add-modal, product-card, .quick-add-modal, .product-card, [data-product-card]');
    return !!container && /Mellowden/i.test(container.textContent || '');
  }

  function buildPanel() {
    const panel = document.createElement('div');
    panel.className = MARKER;
    panel.innerHTML = `
      <div class="mdp-card">
        <p class="mdp-kicker">PERSONALIZE YOUR PORTRAIT</p>
        <h3>Make it unmistakably theirs.</h3>
        <p class="mdp-intro">Upload your pet photo and tell us how you’d like the background handled. You’ll review the finished artwork before anything is printed.</p>
        <div class="mdp-field">
          <label>1. Upload your pet photo <span>*</span></label>
          <input class="mdp-photo" type="file" name="properties[Pet photo]" accept="image/jpeg,image/png,image/webp" required>
          <small>Use a clear, well-lit photo where your pet’s face and markings are easy to see. JPG, PNG or WebP.</small>
          <div class="mdp-preview" hidden style="display:none">
            <img class="mdp-preview-image" alt="" hidden style="display:none">
            <div><strong class="mdp-preview-name"></strong><button type="button" class="mdp-change-photo">Change photo</button></div>
          </div>
        </div>
        <div class="mdp-field">
          <label>2. Background preference</label>
          <select class="mdp-background" name="properties[Background preference]">
            <option value="Artist's choice">Artist’s choice</option>
            <option value="Warm neutral">Warm neutral</option>
            <option value="Light cream">Light cream</option>
            <option value="Muted earthy">Muted earthy</option>
            <option value="Photo-inspired">Keep it photo-inspired</option>
            <option value="Custom">Custom</option>
          </select>
          <div class="mdp-custom-background-wrap" hidden style="display:none;margin-top:10px">
            <input class="mdp-custom-background" type="text" name="properties[Custom background]" maxlength="180" placeholder="e.g. soft sage green, beach sunset, plain beige">
          </div>
        </div>
        <div class="mdp-field"><label>Pet name <span class="mdp-optional">optional</span></label><input type="text" name="properties[Pet name]" maxlength="60" placeholder="e.g. Milo"></div>
        <div class="mdp-field"><label>Special instructions <span class="mdp-optional">optional</span></label><textarea name="properties[Special instructions]" rows="3" maxlength="500" placeholder="Anything you want us to preserve or adjust? Collar details, expression, background notes, etc."></textarea></div>
        <div class="mdp-reassurance">✓ Payment is collected when you place your order. Your portrait is only sent to print after you approve the artwork preview.</div>
        <div class="mdp-error" hidden></div>
      </div>`;
    return panel;
  }

  function setButtonText(button, text) {
    const textNode = button.querySelector('.add-to-cart-text__content > span > span');
    if (textNode) textNode.textContent = text;
    else if (button.tagName === 'INPUT') button.value = text;
    else button.textContent = text;
  }

  function updateCartBadge(cart) {
    const badge = document.querySelector('.mdh-cart-count');
    if (!badge) return;
    const count = Number(cart && cart.item_count) || 0;
    badge.textContent = String(count);
    badge.hidden = count < 1;
  }

  function initForm(form) {
    if (!isMellowdenForm(form) || form.dataset.mellowdenPersonalization === '1') return;
    form.dataset.mellowdenPersonalization = '1';
    form.enctype = 'multipart/form-data';

    const panel = buildPanel();
    const submit = form.querySelector('button[type="submit"], input[type="submit"]');
    if (submit && submit.parentNode) submit.parentNode.insertBefore(panel, submit);
    else form.appendChild(panel);

    form.querySelectorAll('shopify-accelerated-checkout, .shopify-payment-button').forEach((el) => { el.style.display = 'none'; });

    const fileInput = panel.querySelector('.mdp-photo');
    const previewWrap = panel.querySelector('.mdp-preview');
    const previewImage = panel.querySelector('.mdp-preview-image');
    const previewName = panel.querySelector('.mdp-preview-name');
    const changePhoto = panel.querySelector('.mdp-change-photo');
    const background = panel.querySelector('.mdp-background');
    const customWrap = panel.querySelector('.mdp-custom-background-wrap');
    const customInput = panel.querySelector('.mdp-custom-background');
    const error = panel.querySelector('.mdp-error');
    let objectUrl = null;
    let busy = false;

    const showError = (message) => { error.textContent = message; error.hidden = false; error.scrollIntoView({ behavior: 'smooth', block: 'center' }); };
    const clearError = () => { error.textContent = ''; error.hidden = true; };
    const hidePreview = () => {
      if (objectUrl) { URL.revokeObjectURL(objectUrl); objectUrl = null; }
      previewImage.removeAttribute('src'); previewImage.hidden = true; previewImage.style.display = 'none';
      previewWrap.hidden = true; previewWrap.style.display = 'none'; previewName.textContent = '';
    };
    const markAdded = (cart) => {
      updateCartBadge(cart);
      if (!submit) return;
      submit.dataset.mdpGoToCart = 'true';
      submit.type = 'button';
      submit.disabled = false;
      submit.removeAttribute('aria-disabled');
      submit.removeAttribute('data-added');
      setButtonText(submit, 'Go to cart');
    };

    hidePreview();
    fileInput.addEventListener('change', () => {
      const file = fileInput.files && fileInput.files[0];
      if (!file) { hidePreview(); return; }
      if (objectUrl) URL.revokeObjectURL(objectUrl);
      objectUrl = URL.createObjectURL(file);
      previewImage.src = objectUrl; previewImage.hidden = false; previewImage.style.display = 'block';
      previewName.textContent = file.name; previewWrap.hidden = false; previewWrap.style.display = ''; clearError();
    });
    previewImage.addEventListener('error', hidePreview);
    changePhoto.addEventListener('click', () => fileInput.click());
    background.addEventListener('change', () => {
      const custom = background.value === 'Custom';
      customWrap.hidden = !custom; customWrap.style.display = custom ? '' : 'none'; customInput.required = custom;
      if (!custom) customInput.value = ''; clearError();
    });

    form.addEventListener('click', (event) => {
      const button = event.target.closest('button[type="submit"], button[data-mdp-go-to-cart="true"], input[type="submit"]');
      if (!button || !form.contains(button)) return;
      if (button.dataset.mdpGoToCart === 'true') {
        event.preventDefault(); event.stopImmediatePropagation(); window.location.assign(ROOT + 'cart'); return;
      }
      event.stopPropagation();
    }, true);

    form.addEventListener('submit', async (event) => {
      event.preventDefault(); event.stopImmediatePropagation();
      if (submit?.dataset.mdpGoToCart === 'true') { window.location.assign(ROOT + 'cart'); return; }
      if (busy) return;
      if (!fileInput.files || !fileInput.files.length) { showError('Please upload a pet photo before continuing.'); fileInput.focus(); return; }
      if (background.value === 'Custom' && !customInput.value.trim()) { showError('Please describe the custom background you want.'); customInput.focus(); return; }

      clearError(); busy = true;
      const originalText = submit ? (submit.querySelector('.add-to-cart-text__content')?.textContent || 'Add to cart').trim() : 'Add to cart';
      if (submit) { submit.removeAttribute('data-added'); submit.disabled = true; setButtonText(submit, 'Adding…'); }

      try {
        const formData = new FormData(form);
        const variantId = String(formData.get('id') || '');
        const response = await fetch(ROOT + 'cart/add.js', { method: 'POST', body: formData, headers: { Accept: 'application/json' } });
        const payload = await response.json().catch(() => ({}));
        if (!response.ok || payload.status) throw new Error(payload.description || payload.message || 'We couldn’t add this portrait to your cart. Please try again.');

        const cartResponse = await fetch(ROOT + 'cart.js', { headers: { Accept: 'application/json' } });
        if (!cartResponse.ok) throw new Error('Your cart could not be confirmed. Please try again.');
        const cart = await cartResponse.json();
        const added = Array.isArray(cart.items) && cart.items.some((item) => String(item.variant_id) === variantId);
        if (!added) throw new Error('The portrait was not added to your cart. Please try again.');
        markAdded(cart);
      } catch (err) {
        console.error('[Mellowden cart]', err);
        if (submit) { submit.disabled = false; submit.removeAttribute('data-added'); setButtonText(submit, originalText || 'Add to cart'); }
        showError(err && err.message ? err.message : 'We couldn’t add this portrait to your cart. Please try again.');
      } finally { busy = false; }
    }, true);
  }

  function scan(root = document) {
    if (root instanceof Element && root.matches('form[action*="/cart/add"]')) initForm(root);
    root.querySelectorAll?.('form[action*="/cart/add"]').forEach(initForm);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => scan(document)); else scan(document);
  const observer = new MutationObserver((mutations) => { for (const mutation of mutations) for (const node of mutation.addedNodes) if (node.nodeType === 1) scan(node); });
  observer.observe(document.documentElement, { childList: true, subtree: true });
})();